/**
 * آدرس پایهٔ API نسخهٔ v1.
 *
 * پیش‌فرض: سرور production پروژه
 *   https://api.safemeet.ir/api/v1
 *
 * برای محیط محلی در `.env.local` مقداردهی کنید:
 *   REACT_APP_API_BASE_URL=http://localhost:8000/api/v1
 */
const raw =
  process.env.REACT_APP_API_BASE_URL || 'https://api.safemeet.ir/api/v1';

export const API_V1_BASE = String(raw).replace(/\/+$/, '');
